<template>
  <form class="chat-form" @submit="onSubmit">
    <div 
      v-if="form.textarea"
      class="chat-textarea"
    >
      <textarea
        v-model="values['textarea']"
        required
        rows="4"
        :placeholder="$t('chat.enter')"
      >
      </textarea>
    </div>
    <div
      v-for="(input, index) in form.inputs"
      :key="index"
      :class="'chat-' + input.type"
    >
      <input
        :id="fid + '-' + index"
        v-model="values[input.value]"
        :type="input.type"
        :placeholder="$t(input.name)"
        :required="!!input.required"
      />
      <label 
        v-if="input.type === 'checkbox'" 
        :for="fid + '-' + index"
        :class="input.class"
      >
        <a v-if="input.href" :href="input.href" target="_blank">
          {{ $t(input.name) }}
        </a>
        <span v-else>
          {{ $t(input.name) }}
        </span>
      </label>
    </div>

    <div v-for="(obj_html) in form.html" :key="obj_html.id">
      {{ obj_html.id }}
      <a
        v-if="obj_html.tag == 'a'"
        :href="obj_html.href"
        :class="obj_html.class"
        target="_blank"
      >{{ $t(obj_html.text) }}</a>
    </div>
    <div v-if="input_state">
      <input type="submit" :value="form.submit_text" />
    </div>
  </form>
</template>

<script>
import { post } from "axios";
import styleProfile from '../style-profile'
import { apiRequest } from '@/services/api'
import { customLogger } from "@/utils";

export default {
  name: "ChatForm",
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    fid: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      values: {},
      input_state: true
    };
  },
  beforeMount() {
    for (let idx = 0; idx < this.form.inputs.length; ++idx) {
      if (this.form.inputs[idx].input_value) {
        this.values[this.form.inputs[idx].value] = this.form.inputs[
          idx
        ].input_value;
      }
    }
  },
  methods: {
    async onSubmit(e) {
      e.preventDefault();
      this.input_state = !this.input_state
      customLogger("Submitted", this.values, this.form);
      // var js = this.form.on_click
      // eval('(v)=>{customLogger("tuvoisconnardr",v["email"])}')(this.values)
      // customLogger(js)
      // eval(js)(this.values)
      // setting value for history
      Object.keys(this.values).forEach((key) => {
        for (let idx = 0; idx < this.form.inputs.length; ++idx) {
          if (this.form.inputs[idx].value == key) {
            this.form.inputs[idx].input_value = this.values[key];
          }
        }
      });

      // requet form if url exsist
      if (this.form["submit_url"]) {
        const url = this.form["submit_url"];
        const formData = new FormData();
        const reg = /^[0-9]{4,}-[0-9]{2,}-[0-9]{2,}$/;
        const config = {
          headers: {
            "content-type": "multipart/form-data",
            // 'Access-Control-Allow-Origin': "http://shop.manfield.fr:3000"
            // 'Origin': 'https://shop.manfield.fr',
            // 'Referer': 'https://shop.manfield.fr/creation-compte-client.html'
          },
          withCredentials: true,
        };

        Object.keys(this.values).forEach((key) => {
          if (reg.test(this.values[key])) {
            formData.append(
              key,
              this.values[key]
                .split("-")
                .reverse()
                .join("/")
            );
          } else formData.append(key, this.values[key]);
        });

        try {
          await apiRequest().patch('users/update', {
              'firstname': this.values['firstname'],
              'lastname': this.values['lastname'],
              'email': this.values['login']
          })
          customLogger('success')
        } catch (e) {
          customLogger(e)
        }

        try {
          const data = await post(url, formData, config)
          // customLogger("keys response", Object.keys(data));
          // customLogger("OBJ response", res);

          if (
            this.$store.state.config.storeId == 20 ||
            this.$store.state.config.storeId == 16
          ) {
            const bad_res_manfield = /Identifiant ou mot de passe incorrect/g;
            const bad_res_dp = /(Échec d'authentification|Authentication failed)/g;

            if (
              bad_res_manfield.test(res.data) ||
              bad_res_dp.test(res.data)
            ) {
              // bad connection
              if (this.$store.state.user.style_profile) {
                this.$eb.emit(
                  "StyleSubmittedForm",
                  "login.fail",
                  this.values,
                  false
                );
              } else
                this.$eb.emit(
                  "BoxSubmittedForm",
                  "login.fail",
                  this.values,
                  false
                );
            } else {
              // user connected
              if (this.$store.state.user.style_profile) {
                this.$eb.emit(
                  "StyleSubmittedForm",
                  "login.good",
                  this.values,
                  true
                );
              } else
                this.$eb.emit(
                  "BoxSubmittedForm",
                  "login.good",
                  this.values,
                  true
                );
            }
          }
        } catch (e) {
          customLogger("error req", e);
        }
      } else {
        // customLogger('will eval on click')
        //eval(`${this.form.on_click}`)(this.values);
        this.$eb.emit(this.form.on_click, this.values)
        if (this.$store.state.navigation.mode === 'style_profile')
          styleProfile.generateNextStyleProfileStep(this.values)
      }
    },
    postData: async (url = "", data = {}) => {
      // Default options are marked with *
      const response = await fetch(url, {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        mode: "no-cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "include", // include, *same-origin, omit
        headers: {
          "content-type": "multipart/form-data",
          Accept: "*/*",
          // 'Content-Type': 'application/json'
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer-when-downgrade", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: data, // body data type must match "Content-Type" header
      });
      // customLogger("response postData", response);
      return response; // parses JSON response into native JavaScript objects
    },
  },
};
</script>
